"use strict";

var _toConsumableArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/toConsumableArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statistics = exports.sample = void 0;

var Stream_1 = require("../../stream/Stream");

var ConvertersProperty_1 = require("../property/ConvertersProperty");

var Property_generic_1 = require("../property/Property.generic");

var UnbiasedProperty_1 = require("../property/UnbiasedProperty");

var GlobalParameters_1 = require("./configuration/GlobalParameters");

var QualifiedParameters_1 = require("./configuration/QualifiedParameters");

var Tosser_1 = require("./Tosser");

var PathWalker_1 = require("./utils/PathWalker");

function toProperty(generator, qParams) {
  var prop = !Object.prototype.hasOwnProperty.call(generator, 'isAsync') ? new Property_generic_1.Property(generator, function () {
    return true;
  }) : (0, ConvertersProperty_1.convertToNextProperty)(generator);
  return qParams.unbiased === true ? new UnbiasedProperty_1.UnbiasedProperty(prop) : prop;
}

function streamSample(generator, params) {
  var extendedParams = typeof params === 'number' ? Object.assign(Object.assign({}, (0, GlobalParameters_1.readConfigureGlobal)()), {
    numRuns: params
  }) : Object.assign(Object.assign({}, (0, GlobalParameters_1.readConfigureGlobal)()), params);
  var qParams = QualifiedParameters_1.QualifiedParameters.read(extendedParams);
  var nextProperty = toProperty(generator, qParams);
  var shrink = nextProperty.shrink.bind(nextProperty);
  var tossedValues = (0, Stream_1.stream)((0, Tosser_1.toss)(nextProperty, qParams.seed, qParams.randomType, qParams.examples));

  if (qParams.path.length === 0) {
    return tossedValues.take(qParams.numRuns).map(function (s) {
      return s().value_;
    });
  }

  return (0, Stream_1.stream)((0, PathWalker_1.pathWalk)(qParams.path, tossedValues.map(function (s) {
    return s();
  }), shrink)).take(qParams.numRuns).map(function (s) {
    return s.value_;
  });
}

function sample(generator, params) {
  return _toConsumableArray(streamSample(generator, params));
}

exports.sample = sample;

function statistics(generator, classify, params) {
  var extendedParams = typeof params === 'number' ? Object.assign(Object.assign({}, (0, GlobalParameters_1.readConfigureGlobal)()), {
    numRuns: params
  }) : Object.assign(Object.assign({}, (0, GlobalParameters_1.readConfigureGlobal)()), params);
  var qParams = QualifiedParameters_1.QualifiedParameters.read(extendedParams);
  var recorded = {};

  var _iterator = _createForOfIteratorHelper(streamSample(generator, params)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var g = _step.value;
      var out = classify(g);
      var categories = Array.isArray(out) ? out : [out];

      var _iterator3 = _createForOfIteratorHelper(categories),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var c = _step3.value;
          recorded[c] = (recorded[c] || 0) + 1;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var data = Object.entries(recorded).sort(function (a, b) {
    return b[1] - a[1];
  }).map(function (i) {
    return [i[0], "".concat((i[1] * 100.0 / qParams.numRuns).toFixed(2), "%")];
  });
  var longestName = data.map(function (i) {
    return i[0].length;
  }).reduce(function (p, c) {
    return Math.max(p, c);
  }, 0);
  var longestPercent = data.map(function (i) {
    return i[1].length;
  }).reduce(function (p, c) {
    return Math.max(p, c);
  }, 0);

  var _iterator2 = _createForOfIteratorHelper(data),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      qParams.logger("".concat(item[0].padEnd(longestName, '.'), "..").concat(item[1].padStart(longestPercent, '.')));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

exports.statistics = statistics;